module.exports = __webpack_public_path__ + "static/media/withdrawal_refund_policy.e05fde6a.pdf";